import { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import { myWordsQuery } from "../../../../../../validations/myWordsValidation";
import { getListOfWordGroupsApi, getDetalisListOfUserWordsApi } from "../../../../../../services/userSaveWordApi";
import {
  checkErrorMessage,
  checkResponseData,
} from "../../../../utils/utilsFunctions";
import WordGroupQuery from "./WordGroupQuery";
import { Typography } from "@mui/material";
import Chip from '@mui/material/Chip';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IconButton from '@mui/material/IconButton';
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";
import SomeWords from "./SomeWords"

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));


export default function FindWordsQuery(props) {
  const { handleFindQuery } = props;
  const [fromLang, setFromLang] = useState("");
  const [toLang, setToLang] = useState("");
  const [oneMeaning, setOneMeaning] = useState("");
  const [meanings, setMeanings] = useState([]);
  const [groupWords, setGroupWords] = useState({ docs: [] });
  const [allWordsLength, setAllWordsLength] = useState(0);
  const [someWordList, setSomeWordList] = useState(false);



  const getUserWordsFromBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await getDetalisListOfUserWordsApi(data, { perPage: 50, page: 1 })
      let res = checkResponseData(response);
      toast.update(toastMsg, { render: res["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      if (res["data"] && res["data"]["docs"]) {
        // console.log(res["data"])
        let words = []
        res["data"]["docs"].forEach(w => {
          if (words.length < 20)
            words.push(w["word"])
        });
        setSomeWordList(words)
        setAllWordsLength(res["data"]["totalDocs"])
        handleFindQuery(data)
      }
      // toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false,autoClose:3000 });

    } catch (error) {
      console.log(error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });

    }
  };


  const handleAddAndDelete = (type, value = oneMeaning) => {
    if (value.length == 0) return false
    else {
      if (type == "delete") {
        let all = [...meanings]
        all.splice(all.indexOf(value), 1);
        setMeanings(all)
      }
      else if (type == "add") {
        setMeanings([...meanings, value])
        setOneMeaning("")
      }
    }
  };

  const initialValues = {
    fromLang: "",
    toLang: "",
    word: "",
    meanings,
    movieName: "",
    season: "",
    episode: "",
    levelForUser: "",
    // situation: "",
    createdAt_start: "",
    createdAt_end: "",
    groups: [],
  };

  const onSubmit = (values, props) => {
    let data = {
      fromLang: values.fromLang,
      toLang: values.toLang,
      word: values.word,
      meanings,
      movieName: values.movieName,
      season: values.season,
      episode: values.episode,
      levelForUser: values.levelForUser,
      // situation: values.situation,
      createdAt_start: values.createdAt_start,
      createdAt_end: values.createdAt_end,
      groups: values.groups,
    };

    // console.log("newValuesValues", data);
    getUserWordsFromBack(data);
  };

  const handleGroupWordSelected = (props, data) => {
    props.setFieldValue("groups", data);
  };

  const handleDateTime = (date, props, Field) => {
    if (!date) {
      props.setFieldValue(Field, "");
    } else {
      date.convert(gregorian);
      let DateForSend = new DateObject({ date, calender: gregorian }).format(
        "YYYY-MM-DD"
      );
      props.setFieldValue(Field, DateForSend);
      // console.log(Field, DateForSend);
      date.convert(persian);
    }
  };
  const calenderDigits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const getListOfWordGroups = async (data) => {
    try {
      let response = await getListOfWordGroupsApi(data, {})
      const resData = checkResponseData(response);
      setGroupWords(resData["data"])
    } catch (error) {
      console.error(error)

    }
  }
  useEffect(() => {
    getListOfWordGroups({});
  }, []);

  return (
    <Grid
      sx={{ height: "100%", overflowY: "scroll", mt: 1 }}
      container
      spacing={2}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={myWordsQuery}
          onSubmit={onSubmit}
        >
          {(props) => (
            <Form>
              <TableContainer component={Paper}>
                <Table aria-label="customized table">
                  {/* <TableHead>
                    <TableRow>
                      <StyledTableCell
                        sx={{ width: detectSize600px ? "25%" : "50%" }}
                      >
                        فیلتر لغات ذخیره شده
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{ width: detectSize600px ? "75%" : "50%" }}
                      >
                        {" "}
                      </StyledTableCell>
                    </TableRow>
                  </TableHead> */}
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"از زبان"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormControl style={{ minWidth: 170 }}>
                          <InputLabel id="demo-simple-select-label">
                            از زبان
                          </InputLabel>
                          <Select
                            size="small"
                            label="fromLang"
                            name="fromLang"
                            id="fromLang"
                            value={fromLang}
                            onChange={(e) => {
                              setFromLang(e.target.value);
                              props.setFieldValue("fromLang", e.target.value);
                            }}
                          >
                            <MenuItem key={0} value={""}>
                              همه زبان ها
                            </MenuItem>
                            <MenuItem key={1} value={"fa"}>
                              Persian
                            </MenuItem>
                            <MenuItem autoFocus key={2} value="en">
                              English
                            </MenuItem>
                            {Object.keys(languagesList).map((option, index) => (
                              <MenuItem key={index + 3} value={option}>
                                {languagesList[option]}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText
                            sx={{ color: "#f96767", textAlign: "center" }}
                          >
                            <ErrorMessage name="areaCodeTelephoneNumber" />
                          </FormHelperText>
                        </FormControl>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"به زبان"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <FormControl style={{ minWidth: 170 }}>
                          <InputLabel id="demo-simple-select-label">
                            به زبان
                          </InputLabel>
                          <Select
                            size="small"
                            label="toLang"
                            name="toLang"
                            id="toLang"
                            value={toLang}
                            onChange={(e) => {
                              setToLang(e.target.value);
                              props.setFieldValue("toLang", e.target.value);
                            }}
                          >
                            <MenuItem key={0} value={""}>
                              همه زبان ها
                            </MenuItem>
                            <MenuItem key={1} value={"fa"}>
                              Persian
                            </MenuItem>
                            <MenuItem autoFocus key={2} value="en">
                              English
                            </MenuItem>
                            {Object.keys(languagesList).map((option, index) => (
                              <MenuItem key={index + 3} value={option}>
                                {languagesList[option]}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText
                            sx={{ color: "#f96767", textAlign: "center" }}
                          >
                            <ErrorMessage name="areaCodeTelephoneNumber" />
                          </FormHelperText>
                        </FormControl>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"لغت"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Field
                          type="text"
                          size="small"
                          as={TextField}
                          name="word"
                          label="لغت"
                          placeholder="لغت"
                        />
                        <FormHelperText
                          sx={{
                            m: 0,
                            p: 0,
                            color: "#f96767",
                            textAlign: "center",
                          }}
                        >
                          <ErrorMessage name="word" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"ترجمه های لغت(با + اضافه کنید)"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Field
                          type="text"
                          size="small"
                          as={TextField}
                          name="meanings"
                          label="ترجمه های لغت"
                          placeholder="ترجمه های لغت"
                          value={oneMeaning}
                          onChange={(e) => {
                            setOneMeaning(e.target.value)
                          }}
                        />
                        <IconButton aria-label="delete" color="primary" onClick={() => handleAddAndDelete("add")}>
                          <AddBoxIcon />
                        </IconButton>
                        {meanings.map((w, index) => <Chip key={`word-${index}`} label={w}
                          deleteIcon={<DeleteIcon />}
                          onDelete={() => { handleAddAndDelete("delete", w) }}
                        />
                        )}                      <FormHelperText
                          sx={{
                            m: 0,
                            p: 0,
                            color: "#f96767",
                            textAlign: "center",
                          }}
                        >
                          <ErrorMessage name="meanings" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"اسم فیلم"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Field
                          type="text"
                          size="small"
                          as={TextField}
                          name="movieName"
                          label="اسم فیلم"
                          placeholder="اسم فیلم"
                        />
                        <FormHelperText
                          sx={{
                            m: 0,
                            p: 0,
                            color: "#f96767",
                            textAlign: "center",
                          }}
                        >
                          <ErrorMessage name="movieName" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"فصل"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Field
                          type="text"
                          size="small"
                          as={TextField}
                          name="season"
                          label="فصل"
                          placeholder="فصل"
                        />
                        <FormHelperText
                          sx={{
                            m: 0,
                            p: 0,
                            color: "#f96767",
                            textAlign: "center",
                          }}
                        >
                          <ErrorMessage name="season" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"قسمت"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Field
                          type="text"
                          size="small"
                          as={TextField}
                          name="episode"
                          label="قسمت"
                          placeholder="قسمت"
                        />
                        <FormHelperText
                          sx={{
                            m: 0,
                            p: 0,
                            color: "#f96767",
                            textAlign: "center",
                          }}
                        >
                          <ErrorMessage name="episode" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"(تاریخ ذخیره) از تاریخ"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <DatePicker
                          digits={calenderDigits}
                          dateFormat="yyyy-MM-dd"
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                          onChange={(event) => {
                            handleDateTime(event, props, "createdAt_start");
                          }}
                        />
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="createdAt_start" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"(تاریخ ذخیره) تا تاریخ"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <DatePicker
                          digits={calenderDigits}
                          dateFormat="yyyy-MM-dd"
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                          onChange={(event) => {
                            handleDateTime(event, props, "createdAt_end");
                          }}
                        />
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="createdAt_end" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        {"گروه لغات"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <WordGroupQuery
                          groupWords={groupWords}
                          formProps={props}
                          handleGroupWordSelected={handleGroupWordSelected}
                        />
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="groups" />
                        </FormHelperText>
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Button
                type="submit"
                variant="contained"
                sx={{ m: 2 }}
                color="success"
              >
                جست و جو
              </Button>
            </Form>
          )}
        </Formik>
      </Grid>
      <Grid item xs={12}>
        <Typography>
          {`تعداد ${allWordsLength} لغت پیدا شد لطفا روی ادامه کلیک کنید`}
        </Typography>
        {someWordList ? <SomeWords someWordList={someWordList} /> : null}
      </Grid>

    </Grid>
  );
}


const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};

